export const switchStyle = {
    '& .MuiSwitch-thumb': {
        backgroundColor: '#ffffff', // white dot
    },
    '& .MuiSwitch-track': {
        backgroundColor: '#194A6A', // dark blue line (track)
    },
    '&.Mui-checked .MuiSwitch-thumb': {
        backgroundColor: '#ffffff', // keep white when ON
    },
    '.Mui-checked+.MuiSwitch-track': {
        backgroundColor: '#194A6A', // keep same line color when ON
        opacity: 1
    },
};